module.exports = __webpack_public_path__ + "static/media/rupees1.113bf0d2.png";